export { TeamHero } from './TeamHero';
